import { Component, EventEmitter, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { clients, ProcessRunService } from '../../process-runner-select/shared/process-run.service';
import { FORDEARLERDATA, GETNEWVALUES, RELOADNEWVALUES, SeedService } from '../shared/seed.service';
import { Idealerseed, IdealerseedDev } from '../shared/seedinterfaces';

@Component({
  selector: 'app-seed-show-dealer',
  templateUrl: './seed-show-dealer.component.html',
  styleUrls: ['./seed-show-dealer.component.css']
})
export class SeedShowDealerComponent implements OnInit {
  fordeal = FORDEARLERDATA;
  refreshSubscriber$: EventEmitter<string>;
  refreshSubscription: Subscription;
  constructor(private seedSer: SeedService, private processSer: ProcessRunService) {
    this.getConfigAdSeedsDealer();
    this.fetch_clients();
    this.refreshSubscriber$ = this.seedSer.refresher
}
  dataFOrSeedDealers: IdealerseedDev[];
  ngOnInit(): void {
    this.refreshSubscription =  this.refreshSubscriber$.subscribe((r) => {
        if (r == GETNEWVALUES) {
          this.getConfigAdSeedsDealer();
        }
      
    })
  }
  clients: clients[] = []

  async fetch_clients() {
    this.clients = (await this.processSer.getClientes("both").toPromise()) as unknown as clients[];
  }

  ngOnDestroy(): void {
    this.refreshSubscription.unsubscribe();
  }

  getConfigAdSeedsDealer() {
    this.seedSer.getConfigAdSeedsDealer().subscribe((r: Idealerseed[]) => {
      if (r?.length > 0) {
        this.dataFOrSeedDealers = this.createDevData(r);
        this.seedSer.refresher.emit(RELOADNEWVALUES)
      }
    })
  }
  createDevData(data: Idealerseed[]): IdealerseedDev[] {
    let d: IdealerseedDev[] = [];
    data.forEach((da) => {
      d.push({ ...da, selected: false, oldValues: da })
    })
    return d;
  }

}
